import { createContext } from 'react';
import type {
  DirtyStateContextValue,
  ScopeChangeGuardContextValue,
  ScopeResolutionContextValue,
  ScopeTransitionContextValue,
} from './types';

export const ScopeTransitionContext =
  createContext<ScopeTransitionContextValue>({
    pendingTransition: null,
    requestTransition: () => {},
    clearTransition: () => {},
  });

export const ScopeChangeGuardContext =
  createContext<ScopeChangeGuardContextValue>(null);

export const DirtyStateContext = createContext<DirtyStateContextValue>({
  checkScopeIsDirty: () => false,
  markClean: () => {},
  markDirty: () => {},
  clearDirtyState: () => {},
});

export const ScopeResolutionContext =
  createContext<ScopeResolutionContextValue>({
    requireResolution: () => {},
  });
